import React from 'react';

interface Props {
  className: string;
  roleOverflow: number;
}

function RoleOverflowChip({ className, roleOverflow }: Props) {
  return (
    <div className={className}>
      +{roleOverflow} {roleOverflow > 1 ? 'Roles' : 'Role'}
    </div>
  );
}
export default RoleOverflowChip;
